/*
  Re-renders the low stock indicator when the shopper picks another variant.

  The variant picker does not fetch fresh section markup for a variant that is sold out, it
  only marks the button, so the state cannot be swapped in from the server the way the price
  is. It is worked out here instead, from the quantities the block renders for every variant.

  A custom element, so the quick add popup, which re-runs the scripts of the markup it
  injects, neither defines it twice nor leaves listeners behind when it closes.
*/
if (!customElements.get('low-stock-indicator')) {
  customElements.define(
    'low-stock-indicator',
    class LowStockIndicator extends HTMLElement {
      static MIN_FILL = 4;

      connectedCallback() {
        const data = this.querySelector('[data-low-stock-variants]');
        this.variants = data ? JSON.parse(data.textContent) : {};
        this.label = this.querySelector('[data-low-stock-label]');
        this.note = this.querySelector('[data-low-stock-note]');
        this.bar = this.querySelector('[data-low-stock-bar]');
        this.fill = this.querySelector('[data-low-stock-fill]');

        // The picker is a sibling block inside the same product-info, and its own change
        // listener runs first, so currentVariant is already the new one by the time this fires.
        this.scope = this.closest('product-info') || document;
        this.onVariantChange = this.onVariantChange.bind(this);
        this.scope.addEventListener('change', this.onVariantChange);
      }

      disconnectedCallback() {
        if (this.scope) this.scope.removeEventListener('change', this.onVariantChange);
      }

      onVariantChange(event) {
        const picker = event.target.closest('variant-radios, variant-selects');
        if (!picker || !picker.currentVariant) return;

        this.render(this.variants[picker.currentVariant.id]);
      }

      render(variant) {
        const threshold = Number(this.dataset.threshold);
        const quantity = variant ? Number(variant.quantity) || 0 : 0;
        const tracked = variant && variant.management === 'shopify' && variant.policy !== 'continue';

        if (!tracked || quantity > threshold) {
          this.hidden = true;
          return;
        }

        this.hidden = false;

        if (quantity <= 0) {
          this.label.textContent = this.dataset.textSoldOut;
          this.note.textContent = this.dataset.noteSoldOut;
          this.bar.hidden = true;
          return;
        }

        this.label.textContent =
          quantity === 1 ? this.dataset.textLastOne : this.dataset.textOnlyLeft.replace('[quantity]', quantity);
        this.note.textContent = this.dataset.noteRestock;
        this.bar.hidden = false;

        const normalStock = Math.max(Number(this.dataset.normalStock) || 1, 1);
        const percent = Math.round((quantity / normalStock) * 100);
        this.fill.style.width = `${Math.min(100, Math.max(LowStockIndicator.MIN_FILL, percent))}%`;
      }
    }
  );
}
